/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { text, info, secondary, transparent, warning, surface } = colors;

const iconSize = (px) => ({
  "& .material-icons, & .material-icons-round, & svg": {
    fontSize: pxToRem(px),
  },
});

const buttonText = {
  base: {
    backgroundColor: transparent.main,
    minHeight: pxToRem(40),
    color: text.main,
    boxShadow: "none",
    padding: `0 ${pxToRem(16)}`,
    "&:hover": {
      backgroundColor: surface.container,
      boxShadow: "none",
    },
    "&:focus": {
      boxShadow: "none",
    },
    "&:active, &:active:focus, &:active:hover": {
      opacity: 0.85,
      boxShadow: "none",
    },
    "&:disabled": {
      boxShadow: "none",
    },
    ...iconSize(18),
  },

  small: {
    minHeight: pxToRem(32),
    padding: `0 ${pxToRem(12)}`,
    fontSize: pxToRem(12),
    ...iconSize(16),
  },

  large: {
    minHeight: pxToRem(48),
    padding: `0 ${pxToRem(20)}`,
    fontSize: pxToRem(14),
    ...iconSize(20),
  },

  primary: {
    color: info.main,
    "&:hover": {
      color: info.main,
    },
    "&:focus:not(:hover)": {
      color: info.focus,
      boxShadow: "none",
    },
  },

  secondary: {
    color: secondary.main,
    "&:hover": {
      color: secondary.main,
    },
    "&:focus:not(:hover)": {
      color: secondary.focus,
      boxShadow: "none",
    },
  },

  warning: {
    color: warning.main,
    "&:hover": {
      color: warning.main,
    },
    "&:focus:not(:hover)": {
      color: warning.focus,
      boxShadow: "none",
    },
  },
};

export default buttonText;
